import { useEffect, useMemo, useState, } from 'react';
import './App.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter as Router, } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { AppTheme } from './layouts/theme';
import { PropTSCRoutes } from './routes/PropTSCRoutes';
import { loadAppConfigFromSettingsFile } from './helpers/utils';
import { useAppSelector } from './store/store';


function App() {
  const appConfig = useAppSelector(state => state.appConfig.value);
  const theme = useMemo(() => AppTheme(appConfig.DARK_MODE), [appConfig.DARK_MODE])
  const [appConfigLoaded, setAppConfigLoaded] = useState(false);

  useEffect(() => {
    const launchLoadAppConfig = async () => {
      await loadAppConfigFromSettingsFile()
      setAppConfigLoaded(true)
    }
    launchLoadAppConfig()
  }, [])


  return (
    <>
      {appConfigLoaded &&
        <div className="app">
          <Router>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <SnackbarProvider>
                <PropTSCRoutes />
              </SnackbarProvider>
            </ThemeProvider>
          </Router>
        </div>
      }
    </>
  );
}

export default App;
